import { Link, useRouterState } from '@tanstack/react-router';
import React, { ReactNode } from 'react';

const trimTrailingSlash = (path: string) => path.replace(/\/+$/, '') || '/';

const isPathActive = (pathname: string, to: string, exact: boolean) => {
  const current = trimTrailingSlash(pathname);
  const target = trimTrailingSlash(to.split('?')[0]);

  if (exact) {
    return current === target;
  }

  return current === target || current.startsWith(`${target}/`);
};

export const ReactRouterLink = ({
  id,
  to,
  children,
  className,
  exact = false,
}: {
  id: string
  to: string
  children: ReactNode
  className: ({ isActive }: { isActive: boolean }) => string
  exact?: boolean
}) => {
  const pathname = useRouterState({ select: state => state.location.pathname });

  return (
    <Link id={id} to={to} className={className({ isActive: isPathActive(pathname, to, exact) })}>
      {children}
    </Link>
  );
};
